import React from 'react';
import dotIcon from '../img/dot-icon.svg';
import s from './Footer.css';

class Footer extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            now: new Date(),
        };
    }

    render() {
        return (
            <footer className={s.footer}>
                <div className={s.dots}>
                    <img src={dotIcon} alt="" />
                    <img src={dotIcon} alt="" />
                    <img src={dotIcon} alt="" />
                    <img src={dotIcon} alt="" />
                </div>

                <p className={s.copyright}>
                    {'Copyright © Fairview Fittings. All rights reserved. '}
                    <a href="http://rediportal.com" target="_blank">
                        Powered by rediPortal
                    </a>
                    {'.'}
                </p>
            </footer>
        );
    }
}

export default Footer;



// WEBPACK FOOTER //
// ./app/web/src/layout/Footer.jsx